// extracted by mini-css-extract-plugin
export var place = "place-module--place--85cx6";
export var imgContainer = "place-module--img-container--jclY-";
export var img = "place-module--img--HWWxF";
export var link = "place-module--link--cEbYV";
export var footer = "place-module--footer--hucEe";
export var info = "place-module--info--B-Xh0";
export var country = "place-module--country--GOTQt";
export var icon = "place-module--icon--zpBPq";
export var details = "place-module--details--U3iu8";